import PropTypes from 'prop-types';
import React from 'react';
import FooterButton from './FooterButton';
import { getWindowOpener } from './util/dashboardCardHelpers';

var ResourceFooterRightSide = function ResourceFooterRightSide(_ref) {
  var owns = _ref.owns,
      licence = _ref.licence,
      resourceUrl = _ref.resourceUrl,
      resourceId = _ref.resourceId,
      noDownloadButton = _ref.noDownloadButton,
      noBuyButton = _ref.noBuyButton,
      onBasketCheckboxChange = _ref.onBasketCheckboxChange,
      basketCheckboxChecked = _ref.basketCheckboxChecked,
      noAddToBasketCheckbox = _ref.noAddToBasketCheckbox,
      onBuyButtonClick = _ref.onBuyButtonClick,
      onDownloadButtonClick = _ref.onDownloadButtonClick,
      buyButtonHref = _ref.buyButtonHref,
      downloadButtonHref = _ref.downloadButtonHref,
      isSchoolLicenceUpgradeAvailable = _ref.isSchoolLicenceUpgradeAvailable,
      schoolLicenceUpgradeButtonUrl = _ref.schoolLicenceUpgradeButtonUrl;
  return /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__footer__right-side"
  }, owns && !noDownloadButton && isSchoolLicenceUpgradeAvailable && /*#__PURE__*/React.createElement(FooterButton, {
    text: "Upgrade to School Licence",
    href: schoolLicenceUpgradeButtonUrl,
    primary: true,
    mz: "upgrade-to-school-licence"
  }), (owns || licence === 'free') && !noDownloadButton && /*#__PURE__*/React.createElement(FooterButton, {
    text: "Download",
    onClick: !onDownloadButtonClick && !downloadButtonHref ? getWindowOpener(resourceUrl) : onDownloadButtonClick,
    href: downloadButtonHref
  }), !owns && licence !== 'free' && !noAddToBasketCheckbox && /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__footer__add-resource-to-basket"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "add-to-basket-".concat(resourceId),
    checked: basketCheckboxChecked,
    onChange: onBasketCheckboxChange
  }), /*#__PURE__*/React.createElement("label", {
    className: "dashboard-card__footer__add-resource-to-basket__label",
    htmlFor: "add-to-basket-".concat(resourceId)
  }, "Add to basket")), !owns && licence !== 'free' && !noBuyButton && /*#__PURE__*/React.createElement(FooterButton, {
    primary: true,
    text: "View Resource",
    onClick: !onBuyButtonClick && !buyButtonHref ? getWindowOpener(resourceUrl) : onBuyButtonClick,
    href: buyButtonHref
  }));
};

ResourceFooterRightSide.displayName = "ResourceFooterRightSide";
ResourceFooterRightSide.propTypes = {
  owns: PropTypes.bool.isRequired,
  licence: PropTypes.string,
  resourceUrl: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  noDownloadButton: PropTypes.bool,
  noBuyButton: PropTypes.bool,
  noAddToBasketCheckbox: PropTypes.bool,
  onBasketCheckboxChange: PropTypes.func,
  basketCheckboxChecked: PropTypes.bool,
  onBuyButtonClick: PropTypes.func,
  onDownloadButtonClick: PropTypes.func,
  buyButtonHref: PropTypes.string,
  downloadButtonHref: PropTypes.string,
  isSchoolLicenceUpgradeAvailable: PropTypes.bool,
  schoolLicenceUpgradeButtonUrl: PropTypes.string,
  licences: PropTypes.arrayOf(PropTypes.string)
};
ResourceFooterRightSide.defaultProps = {
  onBasketCheckboxChange: function onBasketCheckboxChange() {}
};
export default ResourceFooterRightSide;